module.exports = __webpack_public_path__ + "static/img/product-swipe39.b46ed3db.png";